import React, { Component } from "react";
import "./tweet.css";
import TweetEmbed from "react-tweet-embed";

class Tweet extends Component {
  render() {
    return (
      <div className="tweet">
        <div id="day" className="day">
          <h1 style={{ margin: "1.5rem 0", color: "black", textAlign: "center" }}>
            Tweet of the Day
          </h1>
          <TweetEmbed
            className="ttt"
            id="1423657780934627333"
            placeholder={"loading"}
            options={{ theme: "dark" }}
          />
        </div>

        <div id="lgbtq" className="lgbtq">
          <h1 style={{ margin: "2rem 0", textAlign: "center" }}>LGBTQ+</h1>
          <div style={{ display: "flex", margin: "2rem 0" }}>
            <div
              style={{
                display: "flex",
                backgroundColor: "black",
                width: "fit-content",
                padding: "0.5rem",
                borderRadius: "12px",
                width: "45rem",
                marginRight: "2rem",
              }}
            >
              <img
                className="pic1"
                src={process.env.PUBLIC_URL + "/1.1.jpg"}
              ></img>
              <div>
                <h5 style={{ color: "whitesmoke" }}>
                  "We are each born into this world who we are tall or
                  short, with our own colour of skin with our own sexual
                  orientation. <br /> How can anyone ever tell us we are
                  anything less than beautiful, anything less than
                  whole?"
                </h5>
                <h6 style={{ marginLeft: "15rem", color: "whitesmoke" }}>
                  ~ Brian Kiely
                </h6>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                backgroundColor: "black",
                width: "fit-content",
                padding: "0.5rem",
                borderRadius: "12px",
                width: "45rem",
              }}
            >
              <img
                className="pic1"
                src={process.env.PUBLIC_URL + "/1.2.jpg"}
              ></img>
              <div style={{ margin: "2rem 0" }}>
                <h5 style={{ color: "whitesmoke" }}>
                  This!!! Your whole life is ahead of you, everything is
                  gonna be fine, I promise!! <br /> You have so much time to be
                  who <br /> you want to be and do what you want to do!
                </h5>
              </div>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                backgroundColor: "black",
                width: "fit-content",
                padding: "0.5rem",
                borderRadius: "12px",
                width: "45rem",
                marginRight: "2rem",
              }}
            >
              <img
                className="pic1"
                src={process.env.PUBLIC_URL + "/1.3.jpg"}
              ></img>
              <div>
                <h5 style={{ color: "whitesmoke" }}>
                  You're questioning? That's okay. You're questioning for
                  some really long time or even your whole life? <br /> That's
                  okay! You don't have to find a label, you can just chill and eat ice cream. You change your labels over time?{" "}
                  <br /> Okay! I'm glad you found a label that fits you better.
                </h5>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                backgroundColor: "black",
                width: "fit-content",
                padding: "0.5rem",
                borderRadius: "12px",
                width: "45rem",
              }}
            >
              <img
                className="pic1"
                src={process.env.PUBLIC_URL + "/1.4.jpg"}
              ></img>
              <div>
                <h5 style={{ color: "whitesmoke" }}>
                  <br />"Hey just wanted to say, no matter your sexual or romantic orientation, your gender or lack of it, wether you know it or don't, wether you're sure or not, it is valid and beautiful. And never let anyone tell you otherwise. You're great and you're enough. "
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Tweet;
